import { useState } from "react";

export default function AboutYouForm({ prefs, onSubmit, btnText }) {
    const [form, setForm] = useState({
        name: prefs.name,
        skillLevel: prefs.skillLevel,
        units: prefs.units,
      });
    const buttonText = btnText || "Save";
    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit({ ...prefs, ...form });
    };
  
    return (
        <form onSubmit={handleSubmit} className="space-y-4">
        <InputField label="Name" name="name" value={form.name} onChange={handleChange} />
        <SelectField
          label="Your Cooking Skill Level" // Slightly more personal label
          name="skillLevel"
          value={form.skillLevel}
          onChange={handleChange}
          options={[
            { value: "beginner", label: "Beginner: Just starting out" },
            { value: "intermediate", label: "Intermediate: Comfortable with most recipes" },
            { value: "advanced", label: "Advanced: Confident with complex techniques" },
          ]}
        />        
        <SelectField
          label="Preferred Units"
          name="units"
          value={form.units}
          onChange={handleChange}
          options={[
            { value: "metric", label: "Metric (g, ml, °C)" },
            { value: "imperial", label: "Imperial (oz, lbs, cups, °F)" },
          ]}
        />
        <button className="w-full bg-sage text-white py-2 rounded-3xl hover:bg-sagedark">{buttonText}</button>
      </form>
    );
  }
  
  function InputField({ label, ...props }) {
    return (
      <label className="block">
        <span className="block mb-1">{label}</span>
        <input {...props} className="w-full bg-white p-2 border rounded" />
      </label>
    );
  }
  
  function SelectField({ label, options, ...props }) {
    return (
      <label className="block">
        <span className="block mb-1">{label}</span>
        <select {...props} className="w-full p-2 bg-white border rounded">
          {options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </label>
    );
  }

  